export const SEASONAL_REACTION_PRESETS: Array<Array<string>> = [];
